// Third-party imports
import $ from 'jquery';

// Local imports
import { buttonStateHandler } from './button_handler.js';

// Sets the selected quantity to 1 if there's inventory
// and 0 if there's not.
export function quantityHandler(variantData) {
    if (variantData) {
        let quantity = variantData.variantQuantity === 0 ? 0 : 1;
        $('.js-quantityIncrementer-counter, .js-quantity-hook').val(quantity);
        checkIfProductIsMerchandise(variantData);
    } else {
        // injectVariantMaxQuantityData(1);
    }
}

export function resetQuantityCounter(quantity) {
    quantity = quantity || 1;
    $('.js-quantityIncrementer-counter, .js-quantity-hook').val(quantity);
}

function checkIfProductIsMerchandise(variant) {
    if (variant.isMerchandise && variant.inventoryTracked) {
        injectVariantMaxQuantityData(variant.variantQuantity);
    } else {
        injectVariantMaxQuantityData('doesNotApply');
    }
}

// Injects the max available inventory to a data element
export function injectVariantMaxQuantityData(maxQuantity) {
    $('.js-quantity-hook').data('maxQuantity', maxQuantity);
    $('.js-quantityIncrementer-counter').attr('max', maxQuantity);
    if (maxQuantity === 0) {
        return;
    }

    $('.js-quantityIncrementer-counter, .js-quantity-hook').val(1);
}

export function setButtonStateQuantityClickEvent() {
    $('.js-quantityIncrementer-action').on('click', function() {
        buttonStateHandler();
    });
}
